import axios from "axios";

/**
 * Generates a URL based on specified criteria.
 *
 * - "default" or "maps": Uses client-side shared logic.
 * - "server": Uses server-side logic with environment variables.
 *
 * @param {Object} criteria - Data to be sent in the POST request body.
 * @param {"default" | "maps" | "server"} type - Type of request:
 *    - "default": For general client-side usage.
 *    - "maps": Behaves the same as "default", used for map-related operations.
 *    - "server": For server-side usage, uses environment variables for the API URL.
 * @returns {Promise<any>} - The response data from the API.
 */
export const urlMaker = async (criteria, type) => {
  let apiUrl;

  switch (type) {
    case "server":
      apiUrl = process.env.URL_MAKER_ADDRESS;
      break;

    case "maps":
    case "default":
    default:
      apiUrl = typeof window !== "undefined" ? window.env.URL_MAKER_ADDRESS : process.env.URL_MAKER_ADDRESS;
      break;
  }

  const url = `${apiUrl}v1/url-maker`;

  const response = await axios.post(
    url,
    { ...criteria },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

export const urlMakerBulk = async (criteriaList, type) => {
  let apiUrl;

  switch (type) {
    case "server":
      apiUrl = process.env.URL_MAKER_ADDRESS;
      break;

    case "maps":
    case "default":
    default:
      apiUrl = typeof window !== "undefined" ? window.env.URL_MAKER_ADDRESS : process.env.URL_MAKER_ADDRESS;
      break;
  }

  const url = `${apiUrl}v1/url-maker/bulk`;

  const response = await axios.post(url, criteriaList, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response.data;
};
